import { getRequest, postRequest } from '../request/request.service';
import {
  AfterHoursSettings,
  CompaniesResponse,
  CompanyMessageResponse,
  UpdateAfterHoursSettings,
  UpdateCompanyMessage,
} from './company-service.types';

export function getCompanyMessage(company_name: string) {
  return getRequest<CompanyMessageResponse>(
    `companies/company_messages?company_name=${company_name}`
  );
}

export function updateCompanyMessage(payload: UpdateCompanyMessage) {
  return postRequest(`companies/update_company_messages`, { data: payload });
}

export function getAfterHoursSettings(company_name: string) {
  return getRequest<AfterHoursSettings>('companies/after_hours_settings', {
    params: { company_name },
  });
}

export function updateAfterHoursSettings(payload: UpdateAfterHoursSettings) {
  return postRequest<AfterHoursSettings>('companies/update_after_hours_settings', {
    data: payload,
  });
}

export function getCompanies() {
  return getRequest<CompaniesResponse>(`companies`);
}
